import { render, staticRenderFns } from "./VinylPromoMessage.vue?vue&type=template&id=0b9ef12a&scoped=true&"
import script from "./VinylPromoMessage.vue?vue&type=script&lang=js&"
export * from "./VinylPromoMessage.vue?vue&type=script&lang=js&"
import style0 from "./VinylPromoMessage.vue?vue&type=style&index=0&id=0b9ef12a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b9ef12a",
  null
  
)

export default component.exports